/**
 * Development test utilities
 * Only used in development mode to verify security configuration
 */

const isDevelopment = process.env.NODE_ENV === 'development';

// Test if localhost connections are working
export const testLocalhostConnections = async () => {
  if (!isDevelopment) {
    console.log('🔒 Development tests only run in development mode');
    return;
  }

  console.log('🧪 Testing localhost connections...');

  const testUrls = [
    'http://localhost:5000',
    'http://127.0.0.1:5000',
    'http://localhost:3000',
    'http://127.0.0.1:3000',
  ];

  for (const url of testUrls) {
    try {
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      console.log(`✅ ${url}: ${response.status}`);
    } catch (error) {
      console.log(`❌ ${url}: ${error.message}`);
    }
  }
};

// Test CSP configuration
export const testCSPConfiguration = () => {
  if (!isDevelopment) {
    return;
  }

  console.log('🔒 Testing CSP configuration...');

  // Check if CSP meta tag exists
  const cspMeta = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
  if (cspMeta) {
    console.log('✅ CSP meta tag found');
    console.log('📋 CSP Content:', cspMeta.getAttribute('content'));
  } else {
    console.warn('⚠️ CSP meta tag not found');
  }

  // Check for other security headers
  const securityHeaders = [
    'X-Content-Type-Options',
    'X-Frame-Options',
    'X-XSS-Protection',
    'Referrer-Policy',
    'Permissions-Policy',
  ];

  securityHeaders.forEach((header) => {
    const meta = document.querySelector(`meta[http-equiv="${header}"]`);
    if (meta) {
      console.log(`✅ ${header}: ${meta.getAttribute('content')}`);
    } else {
      console.warn(`⚠️ ${header} not found`);
    }
  });
};

// Test SRI implementation
export const testSRI = () => {
  if (!isDevelopment) {
    return;
  }

  console.log('🔐 Testing Subresource Integrity...');

  const links = document.querySelectorAll('link[integrity]');
  if (links.length > 0) {
    console.log(`✅ Found ${links.length} resources with SRI`);
    links.forEach((link) => {
      console.log(`📦 ${link.href}: ${link.integrity}`);
    });
  } else {
    console.warn('⚠️ No SRI found');
  }
};

// Run all development tests
export const runDevelopmentTests = async () => {
  if (!isDevelopment) {
    return;
  }

  console.log('🚀 Running development security tests...');
  console.log('='.repeat(50));

  testCSPConfiguration();
  console.log('');

  testSRI();
  console.log('');

  await testLocalhostConnections();
  console.log('');

  console.log('='.repeat(50));
  console.log('✅ Development tests completed');
};

// Auto-run tests in development
if (isDevelopment && typeof window !== 'undefined') {
  // Run tests after a short delay to ensure everything is loaded
  setTimeout(() => {
    runDevelopmentTests();
  }, 1000);
}
